import i18n from 'helpers/i18n';
import messages from './messages';
import React from 'react';
import { completeTraining } from 'actions/trainings';
import TrainingActionModal from './TrainingActionModal';

interface CompleteModalProps {
  /** Controls whether the dialog is open. */
  open: boolean;

  /** The ID of the training. */
  trainingId: number;

  /** Callback fired when the component requests to be closed. */
  onClose: () => void;

  /** Callback fired when the training has been marked as completed. */
  afterSubmit: () => void;
}

const CompleteModal: React.FC<CompleteModalProps> = ({
  trainingId,
  ...props
}) => (
  <TrainingActionModal
    {...props}
    title={i18n.ft(messages.completeModal.header)}
    content={i18n.ft(messages.completeModal.content)}
    cancelLabel={i18n.ft(messages.completeModal.cancel)}
    actionLabel={i18n.ft(messages.completeModal.complete)}
    action={() => completeTraining(trainingId)}
    errorField="attendance"
    unknownErrorMessage={i18n.ft(messages.completeModal.unknown)}
  />
);

export default CompleteModal;
